export const districts = [
{
  // Agrabinta District
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "stroke": "#f90101",
        "stroke-width": 1,
        "stroke-opacity": 1,
        "fill": "#a3a3a3",
        "fill-opacity": 0.2
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              106.79667949676514,
              -7.436517707618955
            ],
            [
              106.79663121700287,
              -7.436656009325034
            ],
            [
              106.8006706237793,
              -7.436390044466962
            ],
            [
              106.81762218475342,
              -7.434347428986214
            ],
            [
              106.83345794677734,
              -7.433496336397972
            ],
            [
              106.83993816375732,
              -7.433411227048422
            ],
            [
              106.85899257659912,
              -7.433624000391373
            ],
            [
              106.86384201049803,
              -7.433964437525647
            ],
            [
              106.88276767730713,
              -7.434517647305897
            ],
            [
              106.9054913520813,
              -7.4364751532390745
            ],
            [
              106.91705703735352,
              -7.4371772999794
            ],
            [
              106.91823720932007,
              -7.437304962902431
            ],
            [
              106.92473888397217,
              -7.438134770996946
            ],
            [
              106.93085432052612,
              -7.438709252604823
            ],
            [
              106.93746328353882,
              -7.439496503957108
            ],
            [
              106.95121765136719,
              -7.441751864875981
            ],
            [
              106.95480108261108,
              -7.441836972608167
            ],
            [
              106.95622265338898,
              -7.441642820570016
            ],
            [
              106.95796743035316,
              -7.442093625513024
            ],
            [
              106.95812702178955,
              -7.442454003172582
            ],
            [
              106.9629979133606,
              -7.442773156572186
            ],
            [
              106.96365237236022,
              -7.442751879686104
            ],
            [
              106.96825504302979,
              -7.442858264106198
            ],
            [
              106.97006821632385,
              -7.443081671304387
            ],
            [
              106.97322249412537,
              -7.443496570084811
            ],
            [
              106.9733190536499,
              -7.443411462674676
            ],
            [
              106.9733726978302,
              -7.443124225043512
            ],
            [
              106.97351217269897,
              -7.443124225043512
            ],
            [
              106.97369456291199,
              -7.443326355248014
            ],
            [
              106.97442412376404,
              -7.4437093385378885
            ],
            [
              106.97808265686035,
              -7.444166790362449
            ],
            [
              106.98112964630127,
              -7.444315728062829
            ],
            [
              106.98197722434998,
              -7.444007214198793
            ],
            [
              106.98291063308714,
              -7.443943383717054
            ],
            [
              106.98431611061096,
              -7.44389019164185
            ],
            [
              106.98476672172546,
              -7.443985937372581
            ],
            [
              106.98614001274109,
              -7.4438263611430875
            ],
            [
              106.98692321777344,
              -7.443964660545326
            ],
            [
              106.98808193206787,
              -7.44378380747209
            ],
            [
              106.9888973236084,
              -7.443879553226028
            ],
            [
              106.99084997177124,
              -7.444283812845579
            ],
            [
              106.99104309082031,
              -7.444049767848112
            ],
            [
              106.99175119400023,
              -7.441113556358356
            ],
            [
              106.99284553527832,
              -7.43819860232386
            ],
            [
              106.99280261993408,
              -7.436134718051593
            ],
            [
              106.99228763580322,
              -7.435219797177097
            ],
            [
              106.99286699295044,
              -7.434772974661705
            ],
            [
              106.99398279190063,
              -7.434134655993798
            ],
            [
              106.99567794799805,
              -7.433113344195114
            ],
            [
              106.995849609375,
              -7.423410763692571
            ],
            [
              106.99481964111328,
              -7.420516970154443
            ],
            [
              106.99481964111328,
              -7.4172827077915935
            ],
            [
              106.99481964111328,
              -7.4148995518938605
            ],
            [
              106.99121475219727,
              -7.411495021091383
            ],
            [
              106.9877815246582,
              -7.4089416057193835
            ],
            [
              106.98760986328125,
              -7.405196569741598
            ],
            [
              106.98657989501953,
              -7.401281270838709
            ],
            [
              106.98400497436523,
              -7.395833840640064
            ],
            [
              106.98263168334961,
              -7.3936208029157235
            ],
            [
              106.98022842407227,
              -7.391237519115661
            ],
            [
              106.97713851928711,
              -7.390726813770951
            ],
            [
              106.9713020324707,
              -7.390726813770951
            ],
            [
              106.9661521911621,
              -7.39055657852484
            ],
            [
              106.96443557739258,
              -7.388683986487793
            ],
            [
              106.96512222290038,
              -7.386641149759571
            ],
            [
              106.9683837890625,
              -7.3871518598269725
            ],
            [
              106.9690704345703,
              -7.386130439102037
            ],
            [
              106.96735382080078,
              -7.383917352767423
            ],
            [
              106.96563720703125,
              -7.382385209584663
            ],
            [
              106.96426391601562,
              -7.381704255354987
            ],
            [
              106.96306228637695,
              -7.3789804279524605
            ],
            [
              106.96237564086914,
              -7.376426824532252
            ],
            [
              106.96186065673827,
              -7.373702964644061
            ],
            [
              106.96374893188477,
              -7.3716600587302255
            ],
            [
              106.96683883666992,
              -7.370468359261709
            ],
            [
              106.96975708007811,
              -7.3702981162187475
            ],
            [
              106.97490692138672,
              -7.368255194600058
            ],
            [
              106.97525024414062,
              -7.363147849348567
            ],
            [
              106.97490692138672,
              -7.358040445265046
            ],
            [
              106.973876953125,
              -7.355316472378529
            ],
            [
              106.9690704345703,
              -7.350889980786316
            ],
            [
              106.96529388427734,
              -7.347825460761589
            ],
            [
              106.95602416992188,
              -7.3410153406011425
            ],
            [
              106.95396423339842,
              -7.337950752501019
            ],
            [
              106.95362091064452,
              -7.332502543763999
            ],
            [
              106.95207595825195,
              -7.329139944161443
            ],
            [
              106.95417881011963,
              -7.327863000953187
            ],
            [
              106.96061611175537,
              -7.328501473014831
            ],
            [
              106.96585178375244,
              -7.324883452569241
            ],
            [
              106.96452140808105,
              -7.32373419286929
            ],
            [
              106.96340560913086,
              -7.323308540376677
            ],
            [
              106.96276187896729,
              -7.322840322165417
            ],
            [
              106.96250438690184,
              -7.321903884267808
            ],
            [
              106.96130275726318,
              -7.321903884267808
            ],
            [
              106.95847034454346,
              -7.319988436988639
            ],
            [
              106.95744037628174,
              -7.3179452841575685
            ],
            [
              106.95467233657837,
              -7.320605637565827
            ],
            [
              106.9497799873352,
              -7.3209248789085315
            ],
            [
              106.94647550582886,
              -7.318243244528246
            ],
            [
              106.94085359573364,
              -7.317540909050499
            ],
            [
              106.94027423858643,
              -7.319009427424797
            ],
            [
              106.93557500839233,
              -7.321499512749511
            ],
            [
              106.93471670150757,
              -7.323436236167128
            ],
            [
              106.93321466445921,
              -7.325202690848918
            ],
            [
              106.934072971344,
              -7.32916122651724
            ],
            [
              106.93559646606445,
              -7.332694083483345
            ],
            [
              106.93411588668823,
              -7.334268962496005
            ],
            [
              106.93076848983765,
              -7.333226137826968
            ],
            [
              106.92873001098633,
              -7.333779473669852
            ],
            [
              106.9275712966919,
              -7.332630236919385
            ],
            [
              106.92748546600342,
              -7.3315661261722465
            ],
            [
              106.92667007446288,
              -7.3271819630789805
            ],
            [
              106.92147731781006,
              -7.324585496635245
            ],
            [
              106.9192886352539,
              -7.321691057198621
            ],
            [
              106.91525459289551,
              -7.322670060875779
            ],
            [
              106.91392421722412,
              -7.325138843211279
            ],
            [
              106.91152095794676,
              -7.328033260259088
            ],
            [
              106.91027641296387,
              -7.3319492063341585
            ],
            [
              106.91096305847168,
              -7.334715886606354
            ],
            [
              106.9095468521118,
              -7.336886654473097
            ],
            [
              106.9095468521118,
              -7.337993316369206
            ],
            [
              106.90778732299805,
              -7.340121504586282
            ],
            [
              106.90864562988281,
              -7.343015824219807
            ],
            [
              106.91001892089844,
              -7.3454844937246975
            ],
            [
              106.90958976745604,
              -7.3495279744964215
            ],
            [
              106.90362453460692,
              -7.351528419796933
            ],
            [
              106.90371036529541,
              -7.343867091114902
            ],
            [
              106.90285205841064,
              -7.341909174819575
            ],
            [
              106.89834594726562,
              -7.341100467746976
            ],
            [
              106.89559936523438,
              -7.341398412629028
            ],
            [
              106.89353942871094,
              -7.342036865275561
            ],
            [
              106.89289569854736,
              -7.343867091114902
            ],
            [
              106.89547061920166,
              -7.347059327452506
            ],
            [
              106.89401149749756,
              -7.347655209029275
            ],
            [
              106.89049243927,
              -7.348378778441037
            ],
            [
              106.8876600265503,
              -7.351187919105484
            ],
            [
              106.88414096832275,
              -7.353358606540272
            ],
            [
              106.88087940216064,
              -7.351400732068235
            ],
            [
              106.87680244445801,
              -7.353230919337854
            ],
            [
              106.87585830688477,
              -7.3558697807242455
            ],
            [
              106.87684535980225,
              -7.358934245224846
            ],
            [
              106.87697410583496,
              -7.363105287890897
            ],
            [
              106.87628746032715,
              -7.36476518171206
            ],
            [
              106.87401294708252,
              -7.365148233249705
            ],
            [
              106.87191009521484,
              -7.364297007160987
            ],
            [
              106.87088012695312,
              -7.362722234588108
            ],
            [
              106.87079429626465,
              -7.360764401428473
            ],
            [
              106.87002182006836,
              -7.356635898833394
            ],
            [
              106.86813354492186,
              -7.356295402059267
            ],
            [
              106.86598777770996,
              -7.357359453610965
            ],
            [
              106.86379909515381,
              -7.3617433190887125
            ],
            [
              106.85967922210693,
              -7.3637011479263546
            ],
            [
              106.85894966125487,
              -7.363275533697023
            ],
            [
              106.85736179351807,
              -7.362935042019404
            ],
            [
              106.85568809509277,
              -7.36148794947262
            ],
            [
              106.85654640197754,
              -7.360125975703414
            ],
            [
              106.85899257659912,
              -7.3586363121049825
            ],
            [
              106.86092376708984,
              -7.356721022986109
            ],
            [
              106.86045169830322,
              -7.355018536829739
            ],
            [
              106.85783386230469,
              -7.354337540538767
            ],
            [
              106.85315608978271,
              -7.357274329580727
            ],
            [
              106.85161113739014,
              -7.359657796254376
            ],
            [
              106.84963703155518,
              -7.360466469537805
            ],
            [
              106.8466329574585,
              -7.35680614712249
            ],
            [
              106.84431552886963,
              -7.356465650478982
            ],
            [
              106.84144020080566,
              -7.358763997752288
            ],
            [
              106.83586120605469,
              -7.357104081471244
            ],
            [
              106.83277130126953,
              -7.35808300720873
            ],
            [
              106.83126926422119,
              -7.358125569148317
            ],
            [
              106.82955265045166,
              -7.360466469537805
            ],
            [
              106.82852268218994,
              -7.364594936477963
            ],
            [
              106.82719230651855,
              -7.365573845681082
            ],
            [
              106.82624816894531,
              -7.365573845681082
            ],
            [
              106.82508945465088,
              -7.3644672525094945
            ],
            [
              106.82345867156982,
              -7.3622966194191255
            ],
            [
              106.8226432800293,
              -7.3624243040127135
            ],
            [
              106.81903839111328,
              -7.373319920503166
            ],
            [
              106.80805206298828,
              -7.384513184793554
            ],
            [
              106.80534839630126,
              -7.388045601024702
            ],
            [
              106.80315971374512,
              -7.3888116634697285
            ],
            [
              106.79873943328856,
              -7.389918195767586
            ],
            [
              106.79577827453612,
              -7.391577989017396
            ],
            [
              106.79616451263428,
              -7.393578244389228
            ],
            [
              106.79582118988037,
              -7.396897797135237
            ],
            [
              106.79376125335693,
              -7.397578727946108
            ],
            [
              106.78874015808105,
              -7.396259423545894
            ],
            [
              106.78556442260741,
              -7.3963445400778225
            ],
            [
              106.78298950195312,
              -7.39681268071001
            ],
            [
              106.77942752838135,
              -7.39885547038447
            ],
            [
              106.77706718444823,
              -7.401749406232866
            ],
            [
              106.77625179290771,
              -7.404302863271557
            ],
            [
              106.77685260772705,
              -7.408984162763525
            ],
            [
              106.7792558670044,
              -7.413580299331561
            ],
            [
              106.7821741104126,
              -7.416261356843893
            ],
            [
              106.78380489349365,
              -7.41570812409103
            ],
            [
              106.7868947982788,
              -7.4103034290928935
            ],
            [
              106.78680896759033,
              -7.409196947922554
            ],
            [
              106.78916931152344,
              -7.4081330210998315
            ],
            [
              106.78985595703124,
              -7.408473477962589
            ],
            [
              106.79007053375244,
              -7.409750188855091
            ],
            [
              106.79084300994872,
              -7.41026087217619
            ],
            [
              106.79324626922607,
              -7.414856995421303
            ],
            [
              106.79281711578368,
              -7.415452785662885
            ],
            [
              106.79277420043945,
              -7.4174529327191205
            ],
            [
              106.79363250732422,
              -7.420133966641927
            ],
            [
              106.79363250732422,
              -7.42094252922171
            ],
            [
              106.7949628829956,
              -7.422900095628186
            ],
            [
              106.79530620574951,
              -7.427027978835469
            ],
            [
              106.7951774597168,
              -7.427879083955174
            ],
            [
              106.79646492004393,
              -7.431198378171081
            ],
            [
              106.79616451263428,
              -7.434772974661705
            ],
            [
              106.79667949676514,
              -7.436517707618955
            ]
          ]
        ]
      }
    }
  ]
}
];